import { defineComponent as _defineComponent } from 'vue'
import TmButton from '@/ui/tm-button/tm-button.vue'
import { ConfirmationDialogTextContent } from '@/ui/confirmation-dialog/confirmation-dialog.types'

interface Props {
  textContent: ConfirmationDialogTextContent,
  open: boolean
  confirm: () => void
  cancel: () => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'confirmation-dialog',
  props: {
    textContent: null,
    open: { type: Boolean },
    confirm: null,
    cancel: null
  },
  setup(__props: any) {



return { __sfc: true,TmButton }
}

})